import introSec from "../../../../assets/pen-testing.jpg";
import classrom from "../../../../assets/classrom.jpeg";
import global from "../../../../assets/global.jpeg";
import cyberDiff from "../../../../assets/pen-testing.jpg";
import CybersecurityProgram from "../../Shared/CybersecurityPrograms";

const EthicalHackingPenTesting = () => {
  return (
    <CybersecurityProgram
      backLink="/course/cyber-security"
      heroTitle="Ethical Hacking & Pen Testing"
      heroSubtitle="Identifying and fixing vulnerabilities before attackers exploit them."
      heroImage={introSec}
      introParagraphs={[
        "Ethical Hacking and Penetration Testing are essential practices in modern cybersecurity. They focus on simulating real-world attacks to identify weaknesses in systems, networks, and applications—before malicious hackers can exploit them.",
        "At JR Institute of Information Technology (JRIIT) in Tanzania, students are trained to think like attackers but act as defenders. This module builds the mindset and technical skills needed to ethically test and strengthen digital infrastructure.",
      ]}
      classroom={{
        image: classrom,
        title: "IN THE CLASSROOM",
        paragraphs: [
          "In the classroom, students explore penetration testing methodologies, vulnerability assessment tools, and ethical hacking frameworks such as OWASP and NIST standards. Topics include reconnaissance, scanning, exploitation, privilege escalation, and post-exploitation techniques.",
          "Hands-on labs cover using tools like Nmap, Metasploit, Wireshark, and Burp Suite to conduct ethical attacks on controlled environments. Students also learn to document findings and recommend remediation strategies in professional reports.",
        ],
      }}
      beyondClassroom={{
        image: global,
        title: "BEYOND THE CLASSROOM",
        paragraphs: [
          "Beyond the classroom, learners apply their pen testing skills in internships, Capture the Flag (CTF) competitions, and cybersecurity projects with industry partners.",
          "Graduates of this module often pursue careers as penetration testers, red team members, vulnerability analysts, or cybersecurity consultants, helping organizations strengthen their defenses against evolving threats.",
        ],
      }}
      difference={{
        image: cyberDiff,
        title: "ETHICAL HACKING & PEN TESTING + THE JRIIT DIFFERENCE",
        paragraphs: [
          "What makes JRIIT’s Ethical Hacking & Pen Testing training unique is the blend of hands-on labs, real-world simulations, and strict adherence to ethical standards.",
          "By the end of the module, students don’t just know how to break into systems—they know how to defend them and ensure organizations are prepared against cyber adversaries.",
        ],
      }}
    />
  );
};

export default EthicalHackingPenTesting;
